import React from 'react';
import Introduction from './Introduction';
import Price from './Price';
import StationMap from './StationMap';

const Express = () => {
  return (
    <React.Fragment>
      <Introduction />
      <StationMap />
      <Price />
    </React.Fragment>
  );
};

export default Express;
